import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Screenshots.css';

const Screenshots = () => {
  const { t } = useLanguage();

  const screenshots = [
    {
      url: './assets/run.png',
      alt: 'Run game'
    },
    {
      url: './assets/play.png',
      alt: 'Gameplay Level'
    },
    {
      url: './assets/score.png',
      alt: 'Game Over Screen'
    }
  ];

  return (
    <section className="screenshots">
      <h2 className="section-title glow-text">{t('screenshots.title')}</h2>
      <div className="screenshots-grid">
        {screenshots.map((screenshot, index) => (
          <div key={index} className="screenshot-container pixel-border">
            <img 
              src={screenshot.url}
              alt={screenshot.alt}
              className="screenshot-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Screenshots;